export const APP_NAME = "Finanzas Rafael";

export const LOGO_URL =
  "https://public.readdy.ai/ai/img_res/3b7c770f-b659-4139-8271-bef071bc36b1.png";